import { render } from "./nft-explore.vue?vue&type=template&id=047e7b84"
import script from "./nft-explore.vue?vue&type=script&lang=js"
export * from "./nft-explore.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__